import { createContext } from 'react';

export interface DreamComponentsContextType {
  responsiveImagesEnabled?: boolean;
  responsiveImagesBreakpoints?: number[];
  /** Number of images to eagerly load with high fetchPriority. Remaining images get loading="lazy". */
  imagePriorityThreshold?: number;
  publicationTimeZone?: string;
  externalEmbedEnabled?: boolean;
  /** Full base URL for external embeds (e.g., 'https://abc123.beehiivusercontent.com' or 'http://kiliman.localhiiv:3002') */
  externalEmbedUrl?: string;
  /** BCP-47 locale tag for number/date formatting in components that can't access i18next directly. */
  language?: string;
}

export const DREAM_COMPONENTS_CONTEXT_DEFAULT_VALUES: DreamComponentsContextType = {
  responsiveImagesEnabled: false,
  responsiveImagesBreakpoints: [360, 430],
  publicationTimeZone: undefined,
  externalEmbedEnabled: false,
  externalEmbedUrl: undefined,
  language: 'en-US',
};

export const DreamComponentsContext = createContext<DreamComponentsContextType | undefined>(undefined);

export const ImageIndexContext = createContext<(() => number) | null>(null);
